"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const formik_1 = require("formik");
const loading_1 = __importDefault(require("./loading"));
function FormLayout({ children }) {
    return ((0, preact_1.h)("div", { className: 'relative' },
        children,
        (0, preact_1.h)(loading_1.default, null)));
}
exports.default = FormLayout;
FormLayout.Fields = Fields;
function Fields({ children }) {
    const { isSubmitting, status: isSubmitted } = (0, formik_1.useFormikContext)();
    const hideForm = isSubmitting || isSubmitted;
    return ((0, preact_1.h)("div", { className: `z-5 transition-opacity ${hideForm && 'opacity-30'}` }, children));
}
